import { useEffect } from "react";

/**
 * Custom hook for handling smooth scroll effects and share bar visibility
 * Used across all detail screens (Events, Stores, Offers)
 */
export const useScrollEffect = (
  contentRef: React.RefObject<HTMLDivElement>,
  onVisibilityChange: (visible: boolean) => void,
  maxOffset: number = 120
) => {
  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const currentScrollY = window.scrollY;
        const offset = Math.min(currentScrollY, maxOffset);
        contentRef.current.style.transform = `translateY(-${offset}px)`;

        // Show/hide share bar based on scroll position
        onVisibilityChange(currentScrollY < 100);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [contentRef, onVisibilityChange, maxOffset]);
};
